const Unauthorized  = () => {
    return(
        <div className="d-flex justify-content-center align-items-center" style={{height: '70vh'}} >
            <b>You are not authorizated to access these resources.</b>
        </div>
    )
}

export default Unauthorized;